import React, { Component } from 'react';

export default class Area extends Component {

  render () {

    return (
      <div id={"sensuba-area-" + this.props.model.id.no} className={this.props.className + " sensuba-area"}>
      	{this.props.children}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/game/view/board/Area.js